import { useTranslation } from "react-i18next";
import { FormDatePicker, FormInput } from "@/shared/Components";
import { FormButtonSelect } from "@/shared/Components/Form/FormButtonSelect";
import { useAppSelector } from "@/services/store";
import { currentPersonSelector } from "@/pages/ContactsPage/slice";
import styles from "./styles.module.scss";

export const Edit = () => {
  const { t } = useTranslation();

  const currentPerson = useAppSelector(currentPersonSelector);
  return (
    <div className={styles.root}>
      <FormInput name="firstName" placeholder={t("contactsPage.generalInfo.firstName")} />
      <FormInput name="middleName" placeholder={t("contactsPage.generalInfo.middleName")} />
      <FormInput name="lastName" placeholder={t("contactsPage.generalInfo.lastName")} />
      <FormButtonSelect
        placeholder={t("common.gender")}
        name="gender"
        allowClear
        options={[
          { label: t("common.male"), value: "MALE" },
          { label: t("common.female"), value: "FEMALE" },
          { label: t("common.notDefined"), value: "NOT_DEFINED" },
        ]}
      />
      <FormDatePicker
        isOnlyYearPicker={!currentPerson?.birthdaySDate?.year}
        hideOnlyYearCheckbox={false}
        placeholder={t("settingsPage.general.birthday")}
        name="birthday"
      />
    </div>
  );
};
